// extracted by mini-css-extract-plugin
export var cardLink = "CardAsLink-module--cardLink--2ZhnG";
export var srOnly = "CardAsLink-module--srOnly--2U4Z3";